import { FaCrown } from 'react-icons/fa';

import { currencyFormat } from 'legacy/common/utils/currency';
import useProductTimeGateText from 'hooks/useProductTimeGateText';
import { CartItem } from 'features/organizations/memberships/checkout/types';
import { useTranslation } from 'react-i18next';

type Props = {
  product: CartItem;
};

const SummaryItem = ({ product }: Props) => {
  const { t } = useTranslation(['checkout']);
  const timeGateText = useProductTimeGateText({
    validFrom: product.productData.validFrom,
    validUntil: product.productData.validUntil
  });

  return (
    <li className="flex flex-col gap-2 not-first:border-t-1 border-neutral-200 py-5 rounded-lg">
      <div className="flex align-center">
        <div className="flex-1 py-3">
          <div className="font-bold text-sm flex-1 ">
            {product.productData.product.name}
          </div>
          <div className="font-normal text-sm flex-1 pt-1">
            {t('checkout:oneTimeCharge')}
          </div>
          {timeGateText ? (
            <div className="pt-1 font-normal text-sm">{timeGateText}</div>
          ) : null}
        </div>
        <div className="w-[40px] h-[40px] bg-neutral-200 flex align-center justify-center rounded-lg overflow-hidden">
          {product.productData.product.imageUrl ? (
            <img
              src={product.productData.product.imageUrl}
              className="w-full h-full object-cover object-center"
            />
          ) : (
            <FaCrown size={20} className="text-neutral-500" />
          )}
        </div>
      </div>
      <div className="flex  align-center">
        <div className="font-bold text-sm flex-1">
          {product.metadata.quantity}x
        </div>
        <div className="font-normal text-sm">
          {currencyFormat(product.productData.product.price)}
        </div>
      </div>
    </li>
  );
};

export default SummaryItem;
